export default {
    setClientSettings: (state, payload) => (state.clientSettings = payload),
    setTheSameEmail: state => state.sameEmail = true,
    emailChanged: state => state.emailChanged = true,
    setEmailErrors: (state, payload) => state.emailErrors = payload,
    setDeletionReasons: (state, payload) => state.deletionReasons = payload,
    setAccountDeletionError: (state, payload) => state.accountDeleteError = payload,
    showSuccessMessage: (state) => state.showSuccessMessage = !state.showSuccessMessage
};